/**
 * Sticky menu size
 */

const stickyMenu = {
  headerHeight: null,
  initStickyMenu: () => {
    window.onscroll = () => stickyMenu.scrollFunction();
    stickyMenu.headerHeight = document.querySelector('.site-header').offsetHeight;
  },
  scrollFunction: () => {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      document.querySelector('.logo-container').classList.add('is-sticky');
    } else {
      document.querySelector('.logo-container').classList.remove('is-sticky');
    }
  },
};

export default stickyMenu;
